
import React from "react";
import { Container ,Row , Col } from "reactstrap";
import Commonsection from "../component/UI/Common-section/Commonsection";
import Nftcards from './../component/UI/Nftards/Nftcards';
import { NFT__DATA } from "../assets/data/data";
import  '../Styles/market.css';
import { useState } from "react";


function Market ( ) {

    const [data , setData ] = useState(NFT__DATA);
    
    const   handelItems = () => {

    }

    const handelCtegory = (e) => {

        const FilterValueItem  = e.target.value; 

        if(FilterValueItem === 'Music') {
            const filterData = NFT__DATA.filter( item => item.categorey ===  "Music")
            setData(filterData);
        }

        if(FilterValueItem === 'Art') {
            const filterData = NFT__DATA.filter( item => item.categorey ===  "Art")
            setData(filterData);
        }

        if(FilterValueItem === 'domain-name') {
            const filterData = NFT__DATA.filter( item => item.categorey === "domain-name" )
            setData(filterData);
        }

        if(FilterValueItem === 'trending-card') {
            const filterData = NFT__DATA.filter( item => item.categorey  === "trending-card" )
            setData(filterData);
        } 

        if(FilterValueItem === 'Virtual-world') {
            const filterData = NFT__DATA.filter( item => item.categorey === "Virtual-world" )
            setData(filterData);
        } 

        if ( FilterValueItem === 'all'){ 
            const filterData = NFT__DATA.filter( item => item.categorey  === "Art"  
            ||  item.categorey  === "Music"  || item.categorey  === "domain-name"  ||  
            item.categorey  === "Virtual-world"  ||  item.categorey  === "trending-card"
        )
            setData(filterData);
        }



    }


     //   sorting  data  by hight  mid  low  
    const handelSort = (e) => {

        const FilterValue  = e.target.value;

        if(FilterValue === 'high') {
            const filterData = NFT__DATA.filter( item => item.currentBid > 6)
            setData(filterData);
        }

        if(FilterValue === 'mid') {
            const filterData = NFT__DATA.filter( item => item.currentBid > 5.50  && item.currentBid < 6 )
            setData(filterData);
        }

        if(FilterValue === 'low') {
            const filterData = NFT__DATA.filter( item => item.currentBid > 4.89  &&  item.currentBid < 5.50 )
            setData(filterData);
        } 
        if ( FilterValue === 'all'){
            const filterData = NFT__DATA.filter( item => item.currentBid > 4  )
            setData(filterData);

        }
    }
    
    return(
        <>
            <Commonsection   title={'MarketPlace'}/>
            
            <section>
                <Container>
                    <Row>
                        <Col  lg="12"  className="">
                            <div className="market__product__filter  d-flex  align-items-center  justify-content-between ">
                                <div  className="filter__left   d-flex  align-items-center  gap-5">
                                    <div  className="all__category__filter  mb-4">
                                        <select  onChange={handelCtegory} >
                                            <option  value="all" > All Categories </option>
                                            <option  value="Art" > Art </option>
                                            <option  value="Music" > Music </option>
                                            <option  value="domain-name" > Domain Name </option>
                                            <option  value="Virtual-world" > Virtual World </option>
                                            <option  value="trending-card" > Treindng Cards </option>
                                        </select>
                                    </div>

                                    {/* <div  className="all__items__filter  mb-4">
                                        <select   onChange={handelItems}>
                                            <option>All Items  </option>
                                            <option  value="single-item" > Single Items </option>
                                            <option  value="bundle" >  Bundle </option>
                                        </select>
                                    </div> */}

                                        <div  className="filter__right  mb-4">
                                            
                                            <select   onChange={handelSort} >
                                                <option > Stored By </option>
                                                <option  value="all"> All </option>
                                                <option  value="high" > Rate </option>
                                                <option  value="mid" >  Mide Rate </option>
                                                <option  value="low" >  Low </option>
                                            </select>
                                        </div>

                                </div>

                                {/* <div  className="filter__right  mb-4">
                                    
                                    <select   onChange={handelSort} >
                                        <option > Stored By </option>
                                        <option  value="all"> All </option>
                                        <option  value="high" > Rate </option>
                                        <option  value="mid" >  Mide Rate </option>
                                        <option  value="low" >  Low </option>
                                    </select>
                                </div> */}

                            </div>
                        </Col>

                        {
                            data.map(( item  ) =>  {
                                return(
                                    <Col  lg="3"  md="4"  sm="6"  key={item.id} className="mb-4"  >
                                        <Nftcards   item={item}   />
                                    </Col>
                                )
                            })
                        }





                    </Row>
                </Container>

            </section>
        </>
    );
}

export default Market;

